import { useQueryClient, UseMutationOptions } from "@tanstack/react-query";
import { updateTrackStatus } from "../../api/property-stage";
import { Track } from "../../types";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";

type Variables = {
  uid: string;
  statusId: number;
  files?: any;
  amenities?: Set<string>;
  formSections?: any;
};

type ErrorType = { response?: { data?: { message?: string } } };

export function useUpdateTrackStatus() {
  const queryClient = useQueryClient();

  const options: UseMutationOptions<Track, ErrorType, Variables> = {
    mutationFn: async ({ uid, statusId, files, amenities, formSections }) => {
      const formData = new FormData();
      formData.append(
        "statusFields",
        JSON.stringify({
          statusId,
          propertyFields: formSections ?? [],
        })
      );

      if (amenities) {
        formData.append("amenities", JSON.stringify(Array.from(amenities)));
      }

      if (files && files.length > 0) {
        for (const file of files) {
          formData.append(file.documentType, file.file);
        }
      }

      const response = await updateTrackStatus(uid, formData);
      return response.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["track"],
      });

      queryClient.invalidateQueries({
        queryKey: ["track-status-updates", variables.uid],
      });
    },
  };

  return useDomainMutation(options);
}
